import { render, staticRenderFns } from "./HorizontalTextDivider.vue?vue&type=template&id=04fd0d1e"
import script from "./HorizontalTextDivider.vue?vue&type=script&lang=ts"
export * from "./HorizontalTextDivider.vue?vue&type=script&lang=ts"
import style0 from "./HorizontalTextDivider.vue?vue&type=style&index=0&id=04fd0d1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports